import { render } from "./SegmentoMultiselect.vue?vue&type=template&id=d45f2138"
import script from "./SegmentoMultiselect.vue?vue&type=script&lang=js"
export * from "./SegmentoMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__